<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction />
      <div class="section-body">
        
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="true" newLink="/ClaimForm/request"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/claim_form"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";

export default {
  title: "Claim Form List",
  access_code: "G_LIST01",
  icon: "fas fa-dollar-sign fa-fw",
  components: {},
  order:2,
  data() {
    return {
      gridId: "list01",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    }
  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"])
  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>